import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
	rating: number;
	maxRating?: number;
	size?: "sm" | "md" | "lg";
	interactive?: boolean;
	onRate?: (rating: number) => void;
}

const sizes = { sm: "h-3.5 w-3.5", md: "h-4.5 w-4.5", lg: "h-5.5 w-5.5" };

export function StarRating({ rating, maxRating = 5, size = "md", interactive = false, onRate }: StarRatingProps) {
	return (
		<div className="flex items-center gap-0.5">
			{Array.from({ length: maxRating }, (_, i) => {
				const filled = i < Math.round(rating);
				return (
					<button
						key={i}
						type="button"
						disabled={!interactive}
						onClick={() => interactive && onRate?.(i + 1)}
						className={cn(
							"transition-colors",
							interactive && "cursor-pointer hover:scale-110",
							!interactive && "cursor-default"
						)}
					>
						<Star
							className={cn(
								sizes[size],
								filled
									? "fill-amber-400 text-amber-400"
									: "fill-transparent text-muted-foreground/30"
							)}
						/>
					</button>
				);
			})}
		</div>
	);
}
